import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator, httpsCallable } from "firebase/functions";
import { FIREBASE_CONFIG, ENV, ENVIRONMENTS } from "@/constants";

export class FirebaseService {
    private db;
    private functions;

    private _downloadInitQuizData;
    private _downloadFinalQuizData;

    constructor() {
        try {
            // Initialize Firebase
            const app = initializeApp(JSON.parse(FIREBASE_CONFIG));

            // Initialize Cloud Firestore
            this.db = getFirestore(app);

            // Initialize Cloud Functions
            this.functions = getFunctions(app, 'europe-west6');            

            if (ENV == ENVIRONMENTS.EMULATOR) {
                connectFirestoreEmulator(this.db, "127.0.0.1", 8080);
                connectFunctionsEmulator(this.functions, "127.0.0.1", 5001);
                console.log("Firebase emulator conenected");
            }
            this._downloadInitQuizData= httpsCallable(this.functions, '_downloadInitQuizData');
            this._downloadFinalQuizData = httpsCallable(this.functions, "_downloadFinalQuizData")
        } catch (error) {
            console.error("Error on firebase connection", error);
            console.error(FIREBASE_CONFIG);
            throw error;
        }
    }
    public getDb() {
        return this.db;
    }
}

const firebaseService = ENV == ENVIRONMENTS.DEV ? null : new FirebaseService();

export default firebaseService;
